//SWIPER SLIDER
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".swiper-slider-section");
  const swipers = [];

  sections.forEach((section, index) => {
    const swiperEl = section.querySelector(".slider-swiper");
    if (!swiperEl) return;

    const uniqueClass = `swiper-instance-${index}`;
    swiperEl.classList.add(uniqueClass);

    const nextBtn = section.querySelector(".swiper-btn-next");
    const prevBtn = section.querySelector(".swiper-btn-prev");
    const scrollbarEl = section.querySelector(".swiper-scrollbar");

    // data attributes
    const effect = swiperEl.dataset.effect || "slide";
    const centered = swiperEl.dataset.centered === "true";
    const autoplayEnabled = swiperEl.dataset.autoPlay === "true";
    const loop = swiperEl.dataset.loop === "true";

    const slidesDesktop = parseFloat(swiperEl.dataset.slidesDesktop) || 4;
    const slidesTablet = parseFloat(swiperEl.dataset.slidesTablet) || 3;
    const slidesMobile = parseFloat(swiperEl.dataset.slidesMobile) || 1.2;
    const spaceBetween = parseInt(swiperEl.dataset.spaceBetween) || 40;

    const swiper = new Swiper(`.${uniqueClass}`, {
      direction: "horizontal",
      loop,
      //centeredSlides: centered,
      spaceBetween,
      effect,
        watchOverflow: true,
        allowTouchMove: true,
      autoplay: autoplayEnabled
        ? { delay: 3000, disableOnInteraction: false }
        : false,

      fadeEffect:
        effect === "fade"
          ? { crossFade: true }
          : undefined,

      coverflowEffect:
        effect === "coverflow"
          ? {
              rotate: 0,
              stretch: 30,
              depth: 120,
              modifier: 1,
              slideShadows: false,
            }
          : undefined,

      breakpoints: {
        1280: {
          slidesPerView: slidesDesktop,
          centeredSlides: false, // ❌ desktop NOT centered
        },
        768: {
          slidesPerView: slidesTablet,
          spaceBetween: 20,
          centeredSlides: false, // ❌ tablet NOT centered
        },
        320: {
          slidesPerView: slidesMobile,
          spaceBetween: 10,
          centeredSlides: centered, // ✅ mobile ONLY
        },
      },

      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },

      scrollbar: scrollbarEl
        ? {
            el: scrollbarEl,
            draggable: true,
            dragSize: 75, // ✅ correct way
             snapOnRelease: false,
          }
        : false,
    });

    swipers.push(swiper);
  });



  document.addEventListener("shown.bs.tab", () => {
    swipers.forEach(swiper => swiper.update());
  });

  document.addEventListener("shown.bs.collapse", () => {
    swipers.forEach(swiper => swiper.update());
  });
});



// FAQ PLUS -- MINUS
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.faq-question').forEach(function (question) {
        question.addEventListener('click', function () {
        const parent = this.parentElement;
        const answer = this.nextElementSibling;

        // Remove active from all
        document.querySelectorAll('.faq-item').forEach(function (item) {
            if (item !== parent) {
            item.classList.remove('active');

            const otherAnswer = item.querySelector('.faq-answer');
            if (otherAnswer) {
                otherAnswer.style.display = 'none';
            }
            }
        });

        // Toggle current
        parent.classList.toggle('active');

        if (answer) {
            answer.style.display = answer.style.display === 'block' ? 'none' : 'block';
        }
        });
    });
});


// Smooth Scroll to particlar #
 window.addEventListener('load', function () {

    // CHANGE THIS SELECTOR ONLY IF HEADER CHANGES
    function getOffset() {
      return 150;
    }

    function scrollToHash(id) {
      if (!id || id === '#') return;

      const target = document.querySelector(id);
      if (!target) return;

      const offset = getOffset();

      const top =
        target.getBoundingClientRect().top +
        window.pageYOffset -
        offset;

      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }

    // On page load
    if (window.location.hash && window.location.hash !== '#') {
      scrollToHash(window.location.hash);
    }

    // On anchor click
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        scrollToHash(this.getAttribute('href'));
      });
    });

  });


// // ===== Warrenty Adding =====  
// document.addEventListener('click', function (e) {

//   const btn = e.target.closest('.warranty_cart_item');
//   if (!btn) return;

//   // ===== RADIO BEHAVIOR =====
//   document.querySelectorAll('.warranty_cart_item')
//     .forEach(el => el.classList.remove('is-selected'));

//   btn.classList.add('is-selected');

//   const variantId = btn.dataset.variant;

//   // ===== DAWN CART LOGIC =====
//   const cartObject =
//     document.querySelector('cart-notification') ||
//     document.querySelector('cart-drawer');

//   let formData = new FormData();
//   formData.append('items[][id]', variantId);
//   formData.append('items[][quantity]', '1');

//   if (cartObject) {
//     formData.append(
//       'sections',
//       cartObject.getSectionsToRender().map((section) => section.id)
//     );
//     formData.append('sections_url', window.location.pathname);
//   }

//   fetch(window.Shopify.routes.root + 'cart/add.js', {
//     method: 'POST',
//     body: formData
//   })
//   .then(response => response.json())
//   .then(data => {
//     if (!cartObject) return;
//     cartObject.classList.remove('is-empty');
//     cartObject.renderContents(data);
//   })
//   .catch(error => console.error('Warranty error:', error));

// });


// ===== Warranty Adding =====
document.addEventListener('click', function (e) {

  const btn = e.target.closest('.warranty_cart_item');
  if (!btn) return;

  // RADIO BEHAVIOR
  document.querySelectorAll('.warranty_cart_item')
    .forEach(el => el.classList.remove('is-selected'));

  btn.classList.add('is-selected');

  const spinner = btn.querySelector('.loading__spinner');
  if (spinner) spinner.classList.remove('hidden'); // show spinner

  const variantId = btn.dataset.variant;

  const cartObject =
    document.querySelector('cart-notification') ||
    document.querySelector('cart-drawer');

  let formData = new FormData();
  formData.append('items[][id]', variantId);
  formData.append('items[][quantity]', '1');

  if (cartObject) {
    formData.append(
      'sections',
      cartObject.getSectionsToRender().map(section => section.id)
    );
    formData.append('sections_url', window.location.pathname);
  }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    body: formData
  })
  .then(res => res.json())
  .then(data => {
    if (spinner) spinner.classList.add('hidden'); // hide spinner

    if (!cartObject) return;
    cartObject.classList.remove('is-empty');
    cartObject.renderContents(data);
  })
  .catch(error => {
    if (spinner) spinner.classList.add('hidden');
    console.error('Warranty error:', error);
  });

});